/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'filter': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M14 12v1.361c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V12H14zM22 26v10l4-4v-6l7-11H15l7 11z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/filter.js